import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/website/logo.png'


const _hoisted_1 = { class: "navbar clearfix" }
const _hoisted_2 = { class: "nav clearfix" }
const _hoisted_3 = { class: "clearfix" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "晋才科技"
        })
      ], -1)),
      _createElementVNode("nav", null, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navs, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass({checked:item.checked}),
              onClick: ($event: any) => (_ctx.navClick(index))
            }, _toDisplayString(item.menuName), 11, _hoisted_4))
          }), 128))
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "lang" }, "English/中文", -1))
    ])
  ]))
}